import React from 'react'
import useFetch from "../hooks/useFetch";
import {Container, Row, Col} from "react-bootstrap";




export default function Winnner() {
    const { loading, error, data } = useFetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/winners?sort[0]=Year&populate=*', {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })

    if (loading) return <p>loading...</p>
    if (error) return <p>Error :(</p>


    console.log(data)



    return(
        <div>
            <Container fluid="md">
                <Row>
                    <Col>
                        <div style={{float: "left", marginBottom: 20, marginTop: 30}}>
                            <h1>Sieger</h1>
                        </div>

                    </Col>
                </Row>
                {data.data.map(winnercard => (
                    <Row>
                        <Col>
                            <div key={winnercard.id} className="winner-item" style={{float: "left", marginBottom: 20}}>
                                <div style={{float: "left", marginRight: 20}}><img src={winnercard.Image.url} width={200}/></div>
                                <div style={{float: "left"}}>
                                    <p>{winnercard.Year}: {winnercard.Team}<br />
                                    {winnercard.PlayersName}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                ))}
            </Container>
        </div>
    )

}